import { createContext, useState, useEffect, useContext, use } from "react";
import axios from "axios";
import api from "../components/auth/AddAuthHeader";
import React from "react";

import { DataContext } from "./DataProvider";

export const DataHandlerContext = createContext();

export const DataHandlerProvider = ({ children }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const { handlePopulateEventSeries,eachEventSerieData,eventSeriesData,setMarkFormObject ,getAllMarkFormData,getMarkFormTotalNumbOfSignups} = useContext(DataContext);

  //Edit EventSeries
  const handleSubmitEventSeriesEdit = async (eventSeriesId, data) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/event_series/${eventSeriesId}/edit `,
        data
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
    }
  };

  //Edit Event
  const handleSubmitEventEdit = async (eventSeriesId, eventId, data) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/event_series/${eventSeriesId}/event/${eventId}/edit `,
        data
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Edit Submission
  const handleSubmitSubmissionEdit = async (eventSeriesId, eventId, data) => {
    try {
      setLoadingSubmit(true);

      const updatePromises = Object.entries(data).map(
        ([submissionId, submissionData]) => {
          return api.post(
            `/event_series/${eventSeriesId}/event/${eventId}/submission/${submissionId}/edit`,
            submissionData
          );
        }
      );

      const responses = await Promise.all(updatePromises);

      console.log("Response:", responses);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return responses;
    } catch (error) {
      console.log(error);
      if (error.response?.status !== 200) {
        setErrorSubmit(error);
      }
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Delete submission
  const handleDeleteSubmission = async (
    eventSeriesId,
    eventId,
    submissionId
  ) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/event_series/${eventSeriesId}/event/${eventId}/submission/${submissionId}/delete`
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Delete markForm submission
  const handleDeleteMarkFormSubmission = async (
    formId,
    submissionId
  ) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/form/${formId}/submission/${submissionId}/delete`
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Delete Event
  const handleDeleteEvent = async (eventSeriesId, eventId) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/event_series/${eventSeriesId}/event/${eventId}/delete`
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Add an event
  const handleAddEvent = async (eventSeriesId, data) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/event_series/${eventSeriesId}/event/add`,
        data
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Delete Event Series
  const handleDeleteEventSeries = async (eventSeriesId) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(`/event_series/${eventSeriesId}/delete`);
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

  //Add a submission
  const handleAddSubmission = async (
    eventSeriesId,
    eventId,
    data
  ) => {
    
    
  
    try {
      setLoadingSubmit(true);
  
      const promises = Object.keys(data).map(async (key) => {
        try {
          console.log("ResponseKey:", data[key].first_name);
          const convertBoolean = data[key].marketing === "" ? false : true;
          
          const response = await api.post(
            `/event_series/${eventSeriesId}/event/${eventId}/submission/add`,
            {
              first_name: data[key].first_name,
              job_title: data[key].job_title,
              organisation: data[key].organisation,
              email: data[key].email,
              last_name: data[key].last_name,
              accepts_marketing: convertBoolean,
            }
          );
          
          return {
            success: true,
            data: response.data,
            submission: data[key]
          };
        } catch (error) {
          console.error(`Error processing submission for ${data[key].email}:`, error);
         
          
          return {
            success: false,
            error: error,
            submission: data[key]
          };
        }
      });
      
      const results = await Promise.all(promises);
      
      
      
      setLoadingSubmit(false);
      
      
      return results;
    } catch (error) {
      console.error("Error in handleAddSubmission:", error);
      setErrorSubmit(true);
      setLoadingSubmit(false);
      throw error;
    }
  };
  const handleSubmitMarkFormEdit = async (markFormId,  data) => {
    try {
      setLoadingSubmit(true);

      console.log("Data and markID", data, markFormId);
      const response = await api.post(
        `/form/${markFormId}/edit `,
        data
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };


//Add Mark forms
const addMarkForms = async (data) => {
  try {
    setLoadingSubmit(true);
    const response = await api.post(`/form/add`, data);
    console.log("Response:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
}

//Add Event Series
const addEventSeries = async (data) => {
  try {
    setLoadingSubmit(true);
    const response = await api.post(`/event_series/add`, data);
    console.log("Response:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
}
//Add Event Series Mark form field
const addEventSeriesFormFields = async (data, eventSeriesId) => {
  try {
    setLoadingSubmit(true);
    const response = await api.post(`/events-series/${eventSeriesId}/addeventseriesformfields`, data);
    console.log("Response for all fields:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
};

//Update Event Serie Mark form field 

const updateEventSeriesMarkFormField = async (eventSeriesId,  data) => {

  console.log("Data and markID", data, eventSeriesId);
  try {
    setLoadingSubmit(true);
    const promises = Object.entries(data).map(
      ([setUniqueId, fieldData]) => {
        return api.post(
          `/events-series/${eventSeriesId}/eventseriesformfield/${fieldData.id}/edit`,
          fieldData
        );
      }
    );
 
     const responses = await Promise.all(promises);
     console.log("Response for all fields:", responses);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return responses;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
}





//Add Mark form field
const addMarkFormFields = async (data, formid) => {
  try {
    setLoadingSubmit(true);
    const response = await api.post(`/form/${formid}/addformfields`, data);
    console.log("Response for all fields:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
};


//Update Mark form field 

const updateMarkFormField = async (formid,  data) => {

  console.log("Data and markID", data, formid);
  try {
    setLoadingSubmit(true);
    const promises = Object.entries(data).map(
      ([setUniqueId, fieldData]) => {
        return api.post(
          `/form/${formid}/markformfield/${fieldData.id}/edit`,
          fieldData
        );
      }
    );
 
     const responses = await Promise.all(promises);
     console.log("Response for all fields:", responses);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return responses;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
}

//Delete mark form field
const handleDeleteMarkFormField = async (formid, fieldId) => {
  console.log("FormID and FieldID", formid, fieldId);
  try {
    setLoadingSubmit(true);
    const response = await api.post(
      `/form/${formid}/markformfield/${fieldId}/delete`
    );
    console.log("Response:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
};



//Delete event series form field
const handleDeleteEventSeriesFormField = async (eventSeriesId, fieldId) => {
  console.log("FormID and FieldID", eventSeriesId, fieldId);
  try {
    setLoadingSubmit(true);
    const response = await api.post(
      `/events-series/${eventSeriesId}/eventseriesformfield/${fieldId}/delete`
     

    );
    console.log("Response:", response);
    setLoadingSubmit(false);
    setErrorSubmit(false);
    return response;
  } catch (error) {
    console.log(error);
    setErrorSubmit(error);
    setLoadingSubmit(false);
    throw error;
  }
};


  //Delete mark form
  const handleDeleteMarkForm = async (formId) => {
    try {
      setLoadingSubmit(true);
      const response = await api.post(
        `/form/${formId}/delete`
      );
      console.log("Response:", response);
      setLoadingSubmit(false);
      setErrorSubmit(false);
      return response;
    } catch (error) {
      console.log(error);
      setErrorSubmit(error);
      setLoadingSubmit(false);
      throw error;
    }
  };

// useEffect(() => {
//   getAllMarkFormData();
//   getMarkFormTotalNumbOfSignups();
// },[])


  useEffect(() => {
    handlePopulateEventSeries();
  }, []);

  return (
    <DataHandlerContext.Provider
      value={{
        handleDeleteEventSeries,
        handleAddEvent,
        handleSubmitEventSeriesEdit,
        errorSubmit,
        loadingSubmit,
        handleSubmitEventEdit,
        handleSubmitSubmissionEdit,
        handleDeleteSubmission,
        handleDeleteEvent,
        handleAddSubmission,
        handleDeleteMarkFormSubmission,
        handleSubmitMarkFormEdit,
        addMarkForms,
        addEventSeries,
        addMarkFormFields,
        updateMarkFormField,
        handleDeleteMarkFormField,
        addEventSeriesFormFields,
        updateEventSeriesMarkFormField,
        handleDeleteEventSeriesFormField,
        handleDeleteMarkForm,
      }}
    >
      {children}
    </DataHandlerContext.Provider>
  );
};
